import { render, staticRenderFns } from "./QDKaiJiang.vue?vue&type=template&id=752a4c44&scoped=true"
import script from "./QDKaiJiang.vue?vue&type=script&lang=js"
export * from "./QDKaiJiang.vue?vue&type=script&lang=js"
import style0 from "./QDKaiJiang.vue?vue&type=style&index=0&id=752a4c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752a4c44",
  null
  
)

export default component.exports